import Vue from "vue"
import { SwiperSlide } from "vue-awesome-swiper"

Vue.component("SwiperSlide", SwiperSlide)
